import React, { useEffect, useRef } from 'react'
import * as echarts from 'echarts';
import Grid from '@mui/material/Grid2';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import './reports.css'
function ReportsJobseeker() {
    const navigate = useNavigate();
    const pieFullChartRef = useRef(null);
    const pieChartRef = useRef(null);
    const barChartRef = useRef(null);
    const lineChartRef = useRef(null);

    useEffect(() => {
        if (pieFullChartRef.current) {
        const pieFullChart = echarts.init(pieFullChartRef.current);

        pieFullChart.setOption({
            title: {
                text: 'Referer of a Website',
                subtext: 'Fake Data',
                left: 'center'
            },
            tooltip: {
                trigger: 'item'
            },
            legend: {
                // orient: 'vertical',
                left: 'center'
            },
            series: [
                {
                name: 'Access From',
                type: 'pie',
                radius: '50%',
                data: [
                    { value: 40, name: 'Signup', itemStyle: { color: '#C32A7C' } },
                    { value: 38, name: 'Registration', itemStyle: { color: '#1A5298' } },
                    { value: 32, name: 'Referral Management', itemStyle: { color: '#95DAFF' } },
                    { value: 30, name: 'Service Selection', itemStyle: { color: '#CAECFF' } },
                    { value: 28, name: 'Placement Onboarding', itemStyle: { color: '#124B6A' } },
                ],
                emphasis: {
                    itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
                }
            ]
        });

        // Clean up
        return () => {
            pieFullChart.dispose();
        };
        }
    }, []);

    useEffect(() => {
        if (pieChartRef.current) {
        const pieChart = echarts.init(pieChartRef.current);

        const pieOption = {
            legend: {
            top: 'bottom'
            },
            title: {
                text: 'Jobseeker Stage',
                left: 'center'
            },
            tooltip: {
                trigger: 'item'
            },
            toolbox: {
            show: true,
            feature: {
                mark: { show: true },
                saveAsImage: { show: true }
            }
            },
            series: [
            {
                name: 'Jobseeker Stage',
                type: 'pie',
                radius: [50, 100],
                center: ['50%', '50%'],
                roseType: 'area',
                itemStyle: {
                borderRadius: 5
                },
                data: [
                { value: 40, name: 'Signup', itemStyle: { color: '#C32A7C' } },
                { value: 38, name: 'Registration', itemStyle: { color: '#1A5298' } },
                { value: 32, name: 'Referral Management', itemStyle: { color: '#95DAFF' } },
                { value: 30, name: 'Service Selection', itemStyle: { color: '#CAECFF' } },
                { value: 28, name: 'Placement Onboarding', itemStyle: { color: '#124B6A' } },
                ]
            }
            ]
        };

        pieChart.setOption(pieOption);

        // Clean up
        return () => {
            pieChart.dispose();
        };
        }
    }, []);

    useEffect(() => {
        if (barChartRef.current) {
        const barChart = echarts.init(barChartRef.current);

        const barChartOption = {
            title: {
                text: 'Rate of Joins per Month',
                left: 'center'
            },
            tooltip: {
                trigger: 'item'
            },
            xAxis: {
                type: 'category',
                data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            },
            yAxis: {
                type: 'value'
            },
            series: [
                {
                data: [
                    { value: 190, itemStyle: { color: '#1A5298' } },
                    { value: 100, itemStyle: { color: '#1A5298' } },
                    { value: 50, itemStyle: { color: '#1A5298' } },
                    { value: 170, itemStyle: { color: '#1A5298' } },
                    { value: 120, itemStyle: { color: '#1A5298' } },
                    { value: 190, itemStyle: { color: '#1A5298' } },
                    { value: 100, itemStyle: { color: '#1A5298' } },
                    { value: 50, itemStyle: { color: '#1A5298' } },
                    { value: 170, itemStyle: { color: '#1A5298' } },
                    { value: 120, itemStyle: { color: '#1A5298' } },
                    { value: 170, itemStyle: { color: '#1A5298' } },
                    { value: 120, itemStyle: { color: '#1A5298' } },
                ],
                type: 'bar'
                }
            ]
        };

        barChart.setOption(barChartOption);

        // Clean up
        return () => {
            barChart.dispose();
        };
        }
    }, []);

    useEffect(() => {
        if (lineChartRef.current) {
        const lineChart = echarts.init(lineChartRef.current);

        const lineChartOption = {
            title: {
                text: 'Rate of Joins per week',
                left: 'center'
            },
            tooltip: {
                trigger: 'item'
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
            },
            yAxis: {
                type: 'value'
            },
            series: [
                {
                data: [820, 932, 901, 934, 1290, 1330, 1320],
                type: 'line',
                areaStyle: {}
                }
            ]
        };

        lineChart.setOption(lineChartOption);

        // Clean up
        return () => {
            lineChart.dispose();
        };
        }
    }, []);

    // useEffect(() => {
    //     if (lineChartRef.current) {
    //     const lineChart = echarts.init(lineChartRef.current);

    //     const lineChartOption = {
    //         title: {
    //             text: 'Barchart for Jobseekers',
    //             left: 'center'
    //         },
    //         tooltip: {
    //             trigger: 'item'
    //         },
    //         xAxis: {
    //             type: 'category',
    //             data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri']
    //         },
    //         yAxis: {
    //             type: 'value'
    //         },
    //         series: [
    //             {
    //             data: [
    //                 { value: 190, itemStyle: { color: '#C32A7C' } },
    //                 { value: 100, itemStyle: { color: '#1A5298' } },
    //                 { value: 50, itemStyle: { color: '#95DAFF' } },
    //                 { value: 170, itemStyle: { color: '#CAECFF' } },
    //                 { value: 120, itemStyle: { color: '#124B6A' } },
    //             ],
    //             type: 'bar'
    //             }
    //         ]
    //     };

    //     lineChart.setOption(lineChartOption);

    //     // Clean up
    //     return () => {
    //         lineChart.dispose();
    //     };
    //     }
    // }, []);
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                    <h3>Reports</h3>
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/reports")}>Reports</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Jobseeker Reports</span>
                </Grid>
                <Grid size={{xs:12}} container className="my-3">
                    <Grid size={{md:6, xs:12}} container className="px-2 mt-3">
                        <Grid size={{xs:12}} container className="report_pagecharts">
                            <div ref={pieChartRef} style={{ width: '100%', height: '400px' }} />
                        </Grid>
                    </Grid>
                    <Grid size={{md:6, xs:12}} container className="px-2 mt-3">
                        <Grid size={{xs:12}} container className="report_pagecharts">
                            <div ref={pieFullChartRef} style={{ width: '100%' ,height: '400px' }} />
                        </Grid>
                    </Grid>
                    <Grid size={{md:6, xs:12}} container className="px-2 mt-3">
                        <Grid size={{xs:12}} container className="report_pagecharts">
                            <div ref={barChartRef} style={{ width: '100%' ,height: '400px' }} />
                        </Grid>
                    </Grid>
                    <Grid size={{md:6, xs:12}} container className="px-2 mt-3">
                        <Grid size={{xs:12}} container className="report_pagecharts">
                            <div ref={lineChartRef} style={{ width: '100%' ,height: '400px' }} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default ReportsJobseeker
